const CBT_MODAL_MODES = {
  OPTIONAL: 'optional',
  MANDATORY: 'mandatory',
};

const DEFAULT_TRACK_LOCATION = 'unknown';
const MODAL_TRACK_NAME = 'modal';
const PROTOCOL_PREFIX = 'https:';
const HOST_REDIRECT = 'www.stubhub.ie';
const REDIRECT_TLD = '.ie';

const REDIRECTION_TIMEOUT = 20; // 20 seconds

export {
  CBT_MODAL_MODES,
  PROTOCOL_PREFIX,
  HOST_REDIRECT,
  DEFAULT_TRACK_LOCATION,
  REDIRECTION_TIMEOUT,
  REDIRECT_TLD,
  MODAL_TRACK_NAME,
};

export const COOKIES = {
  AFF_ID: 'aff_affid',
  AFF_AFL: 'aff_afl',
  AFF_TDUID: 'aff_tduid',
  CONVERT_V: '_conv_v',
  CONVERT_S: '_conv_s',
};
